// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const commonClient = require('client-v2/common/client')
// Entry imports
const configureStore = require('client-v2/into-landing/state/store')
const rootFactory = require('client-v2/into-landing/components/root').factory

commonClient.runAfterPageIsLoaded(() => {

  const { store } = commonClient.render(configureStore, rootFactory)
  const { pageName } = store.getState().pageContext

  commonClient.configureSession(store, {
    pageName
  })

  businessEvents.trackSegment('pageview')

})
